export default __webpack_public_path__ + "static/media/singleOrders.645f9998.svg";